module.exports = __webpack_public_path__ + "img/blue_019.22bfb43e.png";